import { Inject, Injectable } from '@angular/core';
import { Value } from '../models/value.model';
import { Observable } from 'rxjs';
import { ENV, IEnvironment } from 'env/config';

import { DataService } from '../http/dataService';
import { CentralApis } from '../interfaces/internal';
import { Config } from '../models/config.model';
import { Repository } from './repository';

import { DropdownCommon } from '../lib/common';
import { Service } from '../entity';
import { map } from 'rxjs/operators';
import { Dropdown, ProvinceConfig } from '../interfaces/helpers';

@Service({
  api: 'config',
  model: Config,
})
@Injectable({ providedIn: 'root' })
export class ConfigService extends Repository<Config> {
  constructor(@Inject(ENV) env: IEnvironment, dataService: DataService) {
    super({
      client: dataService,
      url: (env.api.backend.central.endpoint as CentralApis).appConfig,
    });
  }

  getAll(queryParams?: any) {
    return super.getAll(queryParams);
  }

  getProvinces(configName: string): Observable<Dropdown[]> {
    return super.getOne<Config>(null, configName).pipe(
      map((config) => {
        const provinces: ProvinceConfig[] = JSON.parse(config.value);

        return [
          { value: '', text: DropdownCommon.selectOption, checked: true },
          ...provinces
            .filter((province) => province.active)
            .map((province) => ({
              value: province.value,
              text: province.text,
              checked: true,
            })),
        ];
      })
    );
  }

  createFromDTO(item): Config {
    return Config.createFromDTO(item);
  }
}
